import {get, writable} from 'svelte/store';
import {getTblParam, tableStore} from "../../core/table-store.js";
import {instantTranslate} from "../../core/i18n/language-store.js";

const hasTable = !!getTblParam();
const actionsConfig = M?.actionsConfig || {};

export const actionsNotificationStore = writable({
    opened: false,
    closing: false,
    type: 'success', // 'error', 'none'
    message: ''
});

export const actionsPopupStore = writable({
    opened: false,
    closing: false,
    submittingActionId: null,
    latestSubmit: -1
});

export const actionsStore = writable({
    tenantKey: actionsConfig.tenantKey,
    menuId: actionsConfig.menuId,
    apiUrl: actionsConfig.apiUrl,
    hasActions: (actionsConfig.actions || []).length > 0,
    actions: (actionsConfig.actions || []).map(action => {
        return {
            ...action,
            hideOnDesktop: !(action?.show || []).find(x => x === 'desktop'),
            hideOnMobile: !(action?.show || []).find(x => x === 'mobile'),
            hideWithoutTable: (action?.show || []).find(x => x === 'table-only' && !hasTable),
        }
    })
});

export const showActionNotification = (type, message) => {

    actionsNotificationStore.update(x => {
        x.opened = true;
        x.type = type;
        x.message = message;
        return x;
    });

    setTimeout(() => {
        actionsNotificationStore.update(x => {x.closing = true; return x;});
        setTimeout(() => {hideActionNotification();}, 500);
    }, 5000);
}

export const hideActionNotification = () => {

    actionsNotificationStore.set({
        opened: false, closing: false, type: '', message: '',
    });
}

export const submitAction = async (action) => {

    try {

        // const latestSubmit = get(actionsPopupStore).latestSubmit;
        // if (latestSubmit > 0 && (latestSubmit + action.cooldown) > Date.now()) {
        //     showActionNotification('none', 'Подождите');
        //     return;
        // }

        actionsPopupStore.update(x => {
            x.submittingActionId = action.id;
            x.latestSubmit = Date.now();
            return x;
        });

        const table = get(tableStore);
        const actions = get(actionsStore);

        const req = {
            menuId: actions.menuId,
            tableKey: table.enabled ? table.number : undefined,
            actionId: action.id
        };
        const url = actions.apiUrl;
        const endpoint = url + (url[url.length - 1] === '/' ? '' : '/') + actions.tenantKey;

        const res = await fetch(endpoint, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(req),
            headers: {'content-type': 'application/json'}
        });

        switch (res.status) {

            /// SUCCESS
            case 200:
            case 201:
                const result = await res.json();
                console.log('Submit action result', result);
                if (result?.success && result?.message) {
                    showActionNotification('success', instantTranslate('actions.notifSuccess'));
                }
                else {
                    showActionNotification('error', instantTranslate('actions.notifFailed'));
                }
                break;
            case 404:
                showActionNotification('error', instantTranslate('actions.notifError'));
                break
            default:
                showActionNotification('error', instantTranslate('actions.notifError'));
                break;
        }
    }
    catch (e) {
        showActionNotification('error', instantTranslate('actions.notifError'));
    }
    finally {
        setTimeout(() => {closeActionPopup();}, 300);
    }
}

export const openActionPopup = () => {

    actionsPopupStore.update(x => {
        x.opened = true;
        x.closing = false;
        x.submittingActionId = null;
        return x;
    });
}

export const closeActionPopup = () => {


    actionsPopupStore.update(x => {
        x.opened = true;
        x.closing = true;
        x.submittingActionId = null;
        return x;
    });

    setTimeout(() => {

        actionsPopupStore.update(x => {
            x.opened = false;
            x.closing = false;
            x.submittingActionId = null;
            return x;
        });
    }, 500);
}
